import { Form } from "react-bootstrap";
import { Uploader } from "rsuite";
import { FileType } from "rsuite/esm/Uploader";

export default function InputDnD({
    label,
    name,
    onChangeMethod,
    onBlurMethod,
    accepts,
    errors,
    touched,
    reff,
    value,
    required,
    listType,
    renderFileInfo,
    renderThumbnail,
}: {
    label?: string;
    name: string;
    onChangeMethod: any;
    onBlurMethod?: any;
    accepts: string;
    errors?: string;
    touched?: boolean;
    reff?: any,
    value: FileType | null;
    required?: boolean;
    listType?: "picture" | "text" | "picture-text";
    renderFileInfo?: any;
    renderThumbnail?: any;
}) {

    function onChange(fullArr: FileType[]){
        if(fullArr.length < 1) return null;
        return fullArr[fullArr.length - 1];
    }

    return (
        <>
            <Form.Group className='mb-3'>
                {
                    label && <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>
                }
                <Uploader 
                    draggable 
                    action="www.test.mx/files" 
                    autoUpload={false} 
                    accept={accepts} 
                    multiple={false}
                    fileList={value ? [value] : undefined}
                    onChange={(valueC) => onChangeMethod({ target: { value: onChange(valueC), name } }) }
                    onBlur={onBlurMethod}
                    renderFileInfo={renderFileInfo}
                    renderThumbnail={renderThumbnail}
                    listType={listType}
                >
                    <div style={{ minHeight: "150px", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span className={(errors !== undefined && touched !== undefined ? "text-danger fw-bold" : "")}>
                            Arrastre el archivo sobre el recuadro o haga click para seleccionar un archivo
                            {!label && required && <span className="text-danger">*</span>}
                        </span>
                    </div>
                </Uploader>
            </Form.Group>
        </>
    )
}